/**
 * английские тексты домена: перевод формулировок Кати по контракту голоса
 * (docs/en-voice-contract.md). строчными, как в приложении. длина списков
 * вариантов та же, что в русском: выбор по seed не зависит от языка.
 */
const en1 = (n, one, many) => (n === 1 ? one : many);
const DAYS = (n) => en1(n, 'day', 'days');
const change = (s) => `"${s.name}" ${s.from} → ${s.to}`;
export const en = {
    intl: 'en-GB',
    spheres: {
        sostoyanie: 'state',
        zdorovie: 'health',
        otnosheniya: 'relationships',
        prostranstvo: 'space',
        dengi: 'money',
        produkt: 'product',
        vliyanie: 'influence',
        realizatsiya: 'fulfillment',
    },
    calendar: {
        weekdays: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
        monthsDay: [
            'january', 'february', 'march', 'april', 'may', 'june',
            'july', 'august', 'september', 'october', 'november', 'december',
        ],
        monthsTitle: [
            'january', 'february', 'march', 'april', 'may', 'june',
            'july', 'august', 'september', 'october', 'november', 'december',
        ],
        day: (d, month) => `${d} ${month}`.trim(),
        month: (month, y) => `${month} ${y}`,
    },
    chapters: {
        vychislit: 'how to figure yourself out',
        panDionisAid: 'pan, dionysus and hades',
        nabludatel: 'the observer',
        superpoz: 'eight spheres',
        pletenie: 'weaving the web',
        kapli: 'sticky droplets',
        zaryad: 'electric charge',
        vibracii: 'vibrations of the web',
        estetika: 'aesthetics of the web',
        shelk: 'the economics of silk',
        feromony: 'pheromones',
        terpenie: 'patience',
        evolucia: 'evolution of the web',
    },
    sphereChapters: {
        sostoyanie: 'electric charge',
        zdorovie: 'sticky droplets',
        otnosheniya: 'vibrations of the web',
        prostranstvo: 'weaving context',
        dengi: 'the economics of silk',
        produkt: 'style and signature',
        vliyanie: 'holding attention',
        realizatsiya: 'patience',
    },
    balancedChapter: 'superposition',
    personas: {
        dionis: { name: 'Dionysus', hint: 'dionysus', note: 'dionysus brings back delight and charge.' },
        pan: { name: 'Pan', hint: 'pan', note: 'pan switches on the body, drive and release.' },
        aid: { name: 'Hades', hint: 'hades', note: 'hades clears out the old so the new can grow.' },
        'bog-otec': { name: 'God the Father', hint: 'god the father', note: 'god the father gives the word, the launch and the order.' },
        'bog-syn': { name: 'God the Son', hint: 'god the son', note: 'god the son takes care of the people around you.' },
        'svyatoy-duh': { name: 'the Holy Spirit', hint: 'the holy spirit', note: 'the holy spirit turns what you made into exchange.' },
    },
    prov: {
        sostoyanie: [
            [
                'your state is at rock bottom - and you are dragging the whole system on it.',
                'pull yourself together first, then build the empire. you will not get far on a dead battery, and no discipline makes up for it.',
                '10 minutes of silence, no phone. right now, before the next task.',
            ],
            [
                'you are running on empty and calling it "have to".',
                'nothing alive is made out of exhaustion - only an imitation. your state is not a luxury, it is the fuel for the other seven spheres.',
                'close the laptop for an hour and do something just for yourself.',
            ],
        ],
        zdorovie: [
            [
                'your health has dropped, and it is the only body you have.',
                'wreck the body and there is no one left to receive money and influence. this is not a "when i have time" sphere, it is the foundation everything stands on.',
                'drink some water and go for a 15-minute walk. no goal.',
            ],
        ],
        otnosheniya: [
            [
                'relationships are sinking - and quietly eating the energy you blame on "laziness".',
                'you are not an island. isolation passes for productivity, but it is a leak. people are not a distraction from the work, they are part of the system.',
                'message one person you have been out of touch with for a long time. today.',
            ],
        ],
        prostranstvo: [
            [
                'your space is in chaos - so is your head, and money walks past.',
                'this is not a trifle and not about looks. space is your lever: it turns inner energy into outer results. a clogged channel is a clogged flow.',
                'clear one surface. one. all the way.',
            ],
        ],
        dengi: [
            [
                'money has dropped - but money never drops on its own.',
                'other spheres knock it down. chasing money directly is treating the fever, not the illness. look at what is really pulling it down.',
                'write down which sphere is dragging money down and work on that one - not on money.',
            ],
        ],
        produkt: [
            [
                'there is no product - and nothing to talk about.',
                'influence and money grow from what you make with your hands, not from plans about what you will make. without an artifact the market simply cannot see you.',
                'make one piece of the product today that you can show.',
            ],
        ],
        vliyanie: [
            [
                'influence is at zero - as if you did not exist.',
                'brilliant in a vacuum = nothing. if nobody knows about you, your value exists only in your head. this is not bragging, it is distribution.',
                'publish one thought in public. today, not "when it is ready".',
            ],
        ],
        realizatsiya: [
            [
                'fulfillment has dropped: ideas for ten lifetimes, finished - zero.',
                'fulfillment is where dreams either come alive or quietly die unspoken. the pile of unfinished things weighs more than it seems.',
                'pick one thing and get it to "done" by the end of the week.',
            ],
        ],
    },
    observe: {
        balanced: ({ coh }) => ({
            lead: 'nothing to catch - and that is a diagnosis too.',
            body: `the system is at ${coh}%, every sphere is above the waterline. there is one danger here: to freeze and admire it. superposition is alive only while you keep moving in it.`,
            act: 'raise your strongest sphere by one more point - out of abundance, not need.',
        }),
        contourIn: 'and notice: the inner ring is weaker. it is not about strategy - you have nothing to act from.',
        contourOut: 'fire inside, silence outside. the energy is there, but the channel to the world is clogged - fix space and product, not motivation.',
        lowLead: ({ n }) => `${n} ${en1(n, 'sphere has', 'spheres have')} dropped - money is already losing its footing. `,
    },
    mechanics: {
        'pravilo-dvuh': (c) => ({
            lead: `${c.low.length} ${en1(c.low.length, 'sphere has', 'spheres have')} dropped - energy is leaking down.`,
            body: `${c.low.map(c.nm).join(', ')} below the waterline. when two spheres sink, the system starts to collapse and drags the rest with it.` +
                (c.low.includes('dengi') ? ` ${c.nm('dengi')} is already among them: do not fix it, fix what knocks it down.` : ''),
            act: `do one thing in "${c.nm(c.weakest)}" today - not in all of them at once.`,
        }),
        deficit: (c, _v, p) => ({
            lead: `the deficit shows the way: ${c.nm(c.weakest)}.`,
            body: `${p[1]} a deficit is prey to weave into the web, not to hide.`,
            act: p[2],
        }),
        proficit: (c) => ({
            lead: `${c.nm(c.top)} shines at ${c.values[c.top]} - the surplus feeds.`,
            body: `a surplus glitters and attracts, like droplets on a web. do not spend it on holding on - send it to "${c.nm(c.weakest)}", there is a hole there now.`,
            act: `use the strength of "${c.nm(c.top)}" to take one step in "${c.nm(c.weakest)}".`,
        }),
        kapli: (c, v) => v([
            {
                lead: 'without glue, resources slip through the web.',
                body: 'glue is the number of attempts. not one great attempt, but dozens of small 1s in the matrix. the web holds only what is glued by repetition.',
                act: `put at least one 1 in "${c.nm(c.weakest)}" today.`,
            },
            {
                lead: 'stability is boring. and it works.',
                body: 'sticky droplets are never spectacular. they are just there every day, and that is why the prey does not get away.',
                act: 'pick one skill and mark it seven days in a row. no gaps.',
            },
        ]),
        zaryad: (c) => ({
            lead: 'the web reaches for emotion - and there is no charge.',
            body: `state at ${c.values.sostoyanie}, balance index ${c.coh}%. without charge any system turns into a duty, and you start avoiding it.`,
            act: 'do one thing today purely for pleasure. not useful - alive.',
        }),
        vibracii: () => ({
            lead: 'the web is silent: the signals do not get through.',
            body: 'a spider feels the world through the vibrations of its threads. when the threads sag, you do not know who is near and who resonates. this is not loneliness, it is blindness.',
            act: 'message three people you want to resonate with. no reason needed.',
        }),
        feromony: () => ({
            lead: 'nobody wants you because nobody knows about you.',
            body: 'pheromones are a signal that matches someone else\'s desire. they wanted it themselves, you only gave a sign. silence gives no signs.',
            act: 'publish one thought in which someone will recognize their own desire.',
        }),
        shelk: () => ({
            lead: 'the old web hangs there, the new one is not woven.',
            body: 'a spider digests its old web and spins a new one from it. unfinished work is silk you have not recycled. it does not disappear, it weighs on you.',
            act: 'get one old thing to "done". or close it honestly.',
        }),
        estetika: () => ({
            lead: 'space in chaos - the web is invisible.',
            body: 'camouflage and decoration are not about beauty, they are about how the web works. a cluttered space eats your attention before you even start.',
            act: 'clear one surface down to nothing. just one.',
        }),
        terpenie: () => ({
            lead: 'charge is there, results are not - so you are tugging at the threads.',
            body: 'patience is the strength of stillness. a pause is not emptiness but an action: the spider waits at the center of the web, it does not run along the edges.',
            act: 'pick one task and do not switch away from it for two hours.',
        }),
        kontekst: () => ({
            lead: 'the outer ring, woven from other people\'s threads, tears.',
            body: 'values are the threads context is woven from. if money, product and influence are woven from other people\'s desires, they tear at the first wind.',
            act: 'write down three values of your own and cross out one task that does not serve them.',
        }),
        zhivaya: (c) => ({
            lead: 'nothing to catch - and that is a diagnosis too.',
            body: `the system is at ${c.coh}%, every sphere is above the waterline. if a web is always stretched the same way, it is dead. a living web changes.`,
            act: 'raise your strongest sphere by one more point - out of abundance, not need.',
        }),
    },
    verdict: (() => {
        const score = (d) => `${d.done} of ${d.skills}, ${d.pct}%`;
        const idleList = (idle) => idle.slice(0, 5).join(', ') + (idle.length > 5 ? ` and ${idle.length - 5} more` : '');
        const ZERO_NOTE = [
            'every 0 in the matrix is not a skip, it is a loss: whatever gets no attention, time and energy falls apart.',
            'a 0 is not a pause. a skill without attention melts, and tomorrow you start from less.',
        ];
        return {
            empty: {
                lead: 'the matrix is empty - nothing to observe.',
                body: 'a wheel without a matrix is a mood. point b appears where there are 1s every day.',
                act: 'add three skills to the matrix: one in the inner ring and one in the outer.',
            },
            zero: (d, v) => ({
                lead: v([`0 of ${d.skills} today.`, `not a single 1 out of ${d.skills} today.`]),
                body: `${v(ZERO_NOTE)} while the rows are zeros, point b does not get closer: you are standing at point a and calling it a plan.`,
                act: 'put one 1 before bed. any.',
            }),
            start: (d, v) => {
                const idle = idleList(d.idle);
                return {
                    lead: v([`${score(d)}. good for a start.`, `${score(d)}: a step is taken.`]),
                    body: 'steps like these lead to the goal sooner or later. but if you do not speed up, there will be very little time left for the life you dream of.' +
                        (idle ? ` waiting: ${idle}.` : ''),
                    act: 'add one more 1 today, even the smallest.',
                };
            },
            harsh: (d, v) => {
                const idle = idleList(d.idle);
                return {
                    lead: v([`${score(d)}. seriously? is this your maximum?`, `${score(d)}. this is how people move when nothing will come of it.`]),
                    body: v([
                        'you do exactly enough not to feel ashamed, and exactly enough for nothing to change. a year from now it will be the same, only older.',
                        'most people stop right here and later say they were unlucky. check whether you want to join that line.',
                    ]) + (idle ? ` still without a 1: ${idle}.` : ''),
                    act: 'pick two of them and do them before evening. not tomorrow.',
                };
            },
            pace: (d, v) => ({
                lead: v([`${score(d)}. you are picking up pace.`, `${score(d)}: this already looks like movement.`]),
                body: v([
                    'you look like someone who is at least trying. that is already more than several billion people do.',
                    'trying is no longer zero. most people do not even open the matrix.',
                ]),
                act: d.idle.length ? `bring "${d.idle[0]}" back into play - one 1 today.` : 'close every skill at least once today.',
            }),
            big: (d, v) => ({
                lead: v([`${score(d)}. you are clearly up to something big.`, `${score(d)}: a bid for something outstanding.`]),
                body: v([
                    'but there are plenty of people trying. maybe rest and recovery matter more than success right now - chilling is fine too, for most people. do you want to stay with the majority or move to the next level?',
                    'there are many like you right now: doing half and expecting the whole result. decide where you want to be in a month - in the middle or at the top.',
                ]),
                act: 'add two more skills today - and you are in another league.',
            }),
            worthy: (d, v, narrow) => ({
                lead: v([`${score(d)}. well done.`, `${score(d)}: at this pace people go far.`]),
                body: 'check the wheel: are you growing skills across different spheres, or pouring everything into one sector?' +
                    (narrow ? ` today your 1s sit in only ${d.spheresTouched} ${en1(d.spheresTouched, 'sphere', 'spheres')} - the web is stretching to one side.` : ''),
                act: 'tomorrow, start the day with the sphere that got no 1s today.',
            }),
            spider: (d, v) => ({
                lead: v([`${score(d)}. spider level.`, `${score(d)}: this is how archons work.`]),
                body: v([
                    'archons are rare on earth, and you should not overdo the turbo efficiency.',
                    'a web holds not only on tension but on pause too. overload is another way to break.',
                ]),
                act: 'do a practice in the lake today, and give tomorrow some time to doing nothing.',
            }),
        };
    })(),
    mismatch: {
        doneButLow: ({ sphere, value }) => `in "${sphere}" the skills are being done, yet the score is still ${value}. maybe these skills do not lead to the goal - review them next month.`,
        emptyLow: ({ sphere }) => `"${sphere}" has dropped, and there is not a single skill in it. where would growth come from?`,
    },
    goals: {
        none: 'month two: set goals in the matrix - how many times a month you want to do each skill. and check whether every skill leads to the goal.',
        lost: ({ items, more }) => `too late for these goals: ${items.map((x) => `"${x.name}" (${x.done} of ${x.goal})`).join(', ')}${more > 0 ? ` and ${more} more` : ''}.`,
        behindMany: ({ n }) => `you are behind on ${n} skills - adjust the goals in the matrix so they pull you forward instead of pressing down.`,
        behind: ({ names }) => `behind on: ${names.join(', ')}.`,
        ok: 'this month\'s goals are on pace. keep it up.',
    },
    lake: {
        zero: ({ sphere }) => `if "${sphere}" got no attention today, at least do the practice in the lake.`,
        practice: ({ sphere }) => `do a practice in the lake today: "${sphere}".`,
    },
    haiku: {
        balanced: ({ top }) => [
            ['every thread is taut', 'droplets hold the light', 'touch one - the web is alive'],
            ['the web hums evenly', `"${top}" shines brightest of all`, 'do not freeze in the quiet'],
            ['a spider at the center', 'wind passes, nothing tears', 'keep weaving'],
        ],
        money: ({ money }) => [
            [`the "${money}" thread sags`, 'other threads drag it down', 'find the one pulling'],
            [`"${money}" below the water`, 'money runs along a taut web', 'tighten the thread next to it'],
        ],
        one: ({ weak }) => [
            [`the "${weak}" thread sags`, 'wind passes right through', 'tighten one - and the web will sing'],
            [`"${weak}" below the water`, 'a deficit is prey', 'weave it into the web'],
            [`a hole in the web: "${weak}"`, 'a droplet falls past', 'take one step there'],
        ],
        many: ({ weak, second, money, count }) => [
            [`"${weak}" and "${second}" tear`, 'energy flows down', money !== null ? `and "${money}" is already in the water` : `start with "${weak}"`],
            [`${count} ${en1(count, 'thread', 'threads')} below the water`, 'a spider does not run the edges', `mend "${weak}" first`],
            ['the web sags', `"${weak}" drags "${second}" along`, 'one thread today'],
        ],
    },
    report: {
        filled: ({ filled, days, pct, ones, streak }) => `${filled} of ${days} ${DAYS(days)} filled in (${pct}%), 1s this month: ${ones}. longest streak: ${streak} ${DAYS(streak)}.`,
        balance: ({ from, to }) => {
            const d = to - from;
            return (`balance index: ${from}% → ${to}%` +
                (d > 0 ? ` (+${d}). the system is coming together.` : d < 0 ? ` (${d}). the system is losing its footing - see which spheres pull it down.` : '. no movement.'));
        },
        noBalance: 'satisfaction with your spheres is not visible: record the day on the wheel at least once a week, and the next report will show patterns.',
        keep: ({ list }) => `these skills work: ${list.map(change).join(', ')}. keep them.`,
        replace: ({ list }) => `skills were done, but the sphere is not growing: ${list.map(change).join(', ')}. these skills probably do not lead to the goal - replace them next month.`,
        neglected: ({ list }) => `without attention the sphere sinks: ${list.map(change).join(', ')}. add at least one skill there.`,
        grows: ({ list }) => `growing even without skills: ${list.map(change).join(', ')}. check what exactly feeds it and put that into the matrix.`,
        noSkills: ({ names }) => `spheres without skills: ${names.join(', ')}.`,
        top: ({ items }) => `most often: ${items.map((t) => `${t.name} (${t.ones})`).join(', ')}.`,
        idle: ({ names, more }) => `barely done: ${names.join(', ') + (more > 0 ? ` and ${more} more` : '')}. replace or remove them - empty rows only blur the matrix.`,
        goals: ({ reached, set }) => `goals: ${reached} of ${set} reached.`,
        practices: ({ lake, weak }) => `month two is behind you - time for new practices. ${lake.length ? `the lake has practices for: ${lake.join(', ')}.` : 'new practices appear in the lake every week.'}` +
            (weak !== null ? ` start with "${weak}": it is the lowest now.` : ''),
    },
};
//# sourceMappingURL=en.js.map